// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown.dropdown--quantity[data-v-664d20a8]{border:2px solid #ea60af;margin-bottom:0}.select-holder[data-v-664d20a8]{position:relative}.select-holder select[data-v-664d20a8]{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0}.select-holder input[data-v-664d20a8]{text-align:center;width:100%;pointer-events:none}", ""]);
// Exports
module.exports = exports;
